
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/shopify",
      function () {
        return require("private-next-pages/destinations/shopify.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/shopify"])
      });
    }
  